import {BehaviorSubject} from 'rxjs';

class Modal {
  constructor() {
    this.open = false;
    this.getData = new BehaviorSubject();
  }

  openModal(data) {
    this.open = true;
    this.getData.next(data);
  }

  close() {
    this.open = false;
    this.getData.next(null);
  }
}

export default Modal;
